import impersonationBarView from './impersonationBarComponent.html';
import './impersonationBarComponent.css';

export function impersonationBarComponent() {
	return {
		bindings: {},
		controllerAs: 'vm',
		controller: impersonationBarComponentCtrl,
		template: impersonationBarView,
	};
}

export class impersonationBarComponentCtrl {
	constructor(Api, Identity) {
		'ngInject';
		this.Api = Api;
		const user = Identity.user();
		if (user.impersonator) {
			this.user = user;
		}
	}

	stopImpersonating() {
		this.Api.post('/users/stop_impersonating').then(response => {
			const { payload, token, url } = response;
			localStorage.setItem('jwt', JSON.stringify({ payload, token }));
			window.location.href = url;
		});
	}
}
